define.alias("shared/components/shared/address-fields/suggestions", "media/components/shared/address-fields/suggestions");